import React from 'react';
import PropTypes from 'prop-types';
import CrewfinderExtraModal from './CrewfinderExtraModal';

const CrewfinderExtras = ({
  hasHost, hasAc, hasHalfBoard, hasSkipper, isViewPage,
}) => (
  <div className={`dui-flex dui-justify-between ${isViewPage && ('dui-flex-col dui-gap-2')}`}>
    <CrewfinderExtraModal
      className="dui-flex-1"
      title="Skipper"
      description="Your Quarterdeck professionally trained skipper will sail you around for 7 days: taking care of you, your crew & your yacht"
      icon="skipper"
      isIncluded={hasSkipper}
      isViewPage={isViewPage}
    />
    <CrewfinderExtraModal
      className="dui-flex-1"
      title="Host"
      description="A host on board who will prepare fresh meals for you on deck everyday and keep your yacht in tip-top shape."
      icon="host"
      isIncluded={hasHost}
      isViewPage={isViewPage}
    />
    <CrewfinderExtraModal
      className="dui-flex-1"
      title="Half Board"
      description="This includes all breakfasts, all lunches and two evening meals - which your host will prepare for you. Plus mineral water for your yacht."
      icon="halfboard"
      isIncluded={hasHalfBoard}
      isViewPage={isViewPage}
    />
    <CrewfinderExtraModal
      className="dui-flex-1"
      title="AC"
      description="Air conditioning on a yacht is not of the same standard you may be used to on land! AC on board is designed to be used when docked in the evenings and whilst sleeping. The cooling ability is not as powerful as AC found on land and when used continuously during the day the chance of malfunction increases. During the day, jump up on top deck and enjoy the sea breeze!"
      icon="ac"
      isIncluded={hasAc}
      isViewPage={isViewPage}
    />
  </div>
);

CrewfinderExtras.propTypes = {
  hasAc: PropTypes.bool,
  hasHost: PropTypes.bool,
  hasHalfBoard: PropTypes.bool,
  hasSkipper: PropTypes.bool,
  isViewPage: PropTypes.bool,

};

export default CrewfinderExtras;
